import { from } from 'rxjs'
import { tap, pluck, filter, map } from 'rxjs/operators'
import { APP_MODAL_OPEN, SECRET_QUESTION } from '@/components/Modal/Enum'

export const verifySecretQuestionMissing = emit => notifications => {
  const emitModal = emit(APP_MODAL_OPEN)

  from([notifications])
    .pipe(
      pluck('secretQuestionMissing'),
      filter(secretQuestionMissing => secretQuestionMissing),
      map(() => ({ modal: SECRET_QUESTION })),
      tap(emitModal)
    )
    .subscribe()
}
